import LineChart from "@/components/Common/LineChart/LineChart";
import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
import moment from "moment";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  components: { LineChart },
  async mounted() {
    // await this.$store.dispatch("getNewsConfig");
    await this.$store.dispatch(this.configAction);
    await this.$store.dispatch("getCategoryTypes");
  },
  props: {
    entityType: { type: String, required: true }, // "news", "poi", "event", etc.
    configAction: { type: String, required: true }, // e.g., "getNewsConfig"
    latestDataEndpoint: { type: String, required: true }, // e.g., env.news_api_client_url + "news"
    matomoEndpoint: { type: String, required: true },
    matomoSiteId: { type: Number, required: true },
    matomoTokenAuth: { type: String, required: true },
    title: { type: String, default: "" },
    name: { type: String, default: "" },
    overviewTitle: { type: String, default: "" },
    overviewLink: { type: String, default: "" }
  },
  data() {
    const sumVisitsChartConfig = {
      config: {},
      sumVisitsData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      },
      options: {
        legend: {
          display: true
        },
        responsive: true,
        maintainAspectRatio: false
      },
      chartStyle: { height: "300px", position: "relative" }
    };

    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setDate(today.getDate() - 30);

    return {
      fromDate: lastMonth.toISOString().split("T")[0], // Default to last 30 days
      toDate: today.toISOString().split("T")[0],
      selectedApiKey: "",
      selectedResolution: "day",
      selectedNews: "",
      dropdownApiKeys: [], // Dummy API keys
      sumVisitsChartConfig,
      tableReferer: [],
      tableItems: [],
      tableApiKeys: [],
      latestNews: [],
      resolution: [
        { name: "Täglich", value: "day" },
        { name: "Wöchentlich", value: "week" },
        { name: "Monatlich", value: "month" }
      ],
      matomoUrl: this.matomoEndpoint, // "https://matomo.api.eo-heimat.de"
      tokenAuth: this.matomoTokenAuth, // "1c2f21e8917246077e3d0a1537c44ff3"
      idSite: this.matomoSiteId, // Your site ID
      menu1: false,
      menu2: false,
      totalVisits: 0,
      visible: true,
      message: "",
      linkTitle: this.overviewTitle,
      linkUrl: this.overviewLink,
      inquiryStatistics: null
    };
  },
  methods: {
    formatDropdownText(item) {
      return `${item.apiKey} - ${item.description}`;
    },

    getFetchParams() {
      const principalId = this.currentPrincipal;

      if (this.entityType === "news") {
        return {
          principal_id: principalId,
          limit: 100,
          offset: 0,
          sort: "create_date",
          direction: "asc",
          deleted: false
        };
      } else if (this.entityType === "poi") {
        return {
          $limit: 100,
          $skip: 0,
          "$sort[title]": 1,
          currentPrincipal: principalId,
          extended: true,
          backendSearch: true
        };
      } else if (this.entityType === "event") {
        return {
          principal_id: principalId,
          type: "series",
          active: true,
          limit: 100,
          page: 1,
          sort: "start",
          direction: "desc",
          deleted: false
        };
      }

      // fallback
      return {};
    },

    async fetchLatestNews() {
      await this.$store.dispatch(this.configAction);

      const headers = getTokenHeader();
      const params = this.getFetchParams();

      try {
        const response = await axios.get(this.latestDataEndpoint, {
          headers,
          params
        });
        if (this.entityType === "news") {
          this.latestNews = response.data;
        } else if (this.entityType === "poi") {
          this.latestNews = response.data.data;
        } else if (this.entityType === "event") {
          this.latestNews = response.data;
        }
      } catch (error) {
        this.createError(error);
      }
    },

    async fetchData() {
      await this.$store.dispatch(this.configAction);

      const {
        fromDate,
        toDate,
        selectedResolution,
        selectedNews,
        selectedApiKey
      } = this;

      if (this.apiKeysArray.length !== 0) {
        this.message = "";
        this.visible = true;
      } else {
        this.message = "Keine API-Keys vorhanden";
        this.visible = false;
        return; // !important
      }

      const segmentFilter = selectedApiKey
        ? `userId==${selectedApiKey}`
        : this.apiKeysArray.length > 0
        ? this.apiKeysArray.map(key => `userId==${key}`).join(",")
        : "userId==NO_API_KEY"; // Ensures no data is returned if no valid keys exist

      try {
        let response = null;

        response = await axios.get(this.matomoUrl + "/index.php", {
          params: {
            module: "API",
            method: "VisitsSummary.get", // General summary of visits
            idSite: this.idSite,
            period: "range",
            date: `${fromDate},${toDate}`, // Selected date range
            format: "json",
            segment: segmentFilter, // Optional: Filter directly in API call
            token_auth: this.tokenAuth,
            random: Date.now() // Avoid caching issues
          }
        });

        this.updateTotalVisits(response.data);

        if (selectedNews == null || selectedNews === "") {
          response = await axios.get(this.matomoUrl + "/index.php", {
            params: {
              module: "API",
              method: "Actions.get",
              idSite: this.idSite,
              period: selectedResolution,
              date: `${fromDate},${toDate}`, // Use the selected date range
              format: "json",
              segment: segmentFilter, // Filter directly in API call
              token_auth: this.tokenAuth,
              random: Date.now() // Add a random parameter to avoid caching issues
            }
          });
        } else {
          response = await axios.get(this.matomoUrl + "/index.php", {
            params: {
              module: "API",
              method: "Actions.getPageTitle",
              pageName: selectedNews,
              idSite: this.idSite,
              period: selectedResolution,
              date: `${fromDate},${toDate}`, // Use the selected date range
              format: "json",
              segment: segmentFilter, // Filter directly in API call
              token_auth: this.tokenAuth,
              random: Date.now() // Add a random parameter to avoid caching issues
            }
          });
        }

        if (this.hasConferences) {
          this.inquiryStatistics = await this.getConferenceInquiryStatistics();
        }

        // Process the response to update the chart
        this.updateChartData(response.data);

        response = await axios.get(this.matomoUrl + "/index.php", {
          params: {
            module: "API",
            method: "Referrers.getWebsites",
            idSite: this.idSite,
            period: "range",
            date: `${fromDate},${toDate}`, // Use the selected date range
            format: "json",
            segment: segmentFilter, // Filter directly in API call
            token_auth: this.tokenAuth,
            random: Date.now() // Add a random parameter to avoid caching issues
          }
        });

        this.updateReferersData(response.data);

        response = await axios.get(this.matomoUrl + "/index.php", {
          params: {
            module: "API",
            method: "Actions.getPageTitles", // Fetch page titles
            idSite: this.idSite, // Your site ID
            period: "range", // Using range period
            date: `${this.fromDate},${this.toDate}`, // Date range
            format: "json", // Response format
            segment: segmentFilter, // Filter directly in API call
            token_auth: this.tokenAuth, // Authentication token
            random: Date.now() // Random parameter to avoid caching
          }
        });

        this.updatePageTitlesData(response.data);

        response = await axios.get(this.matomoUrl + "/index.php", {
          params: {
            module: "API",
            method: "UserId.getUsers", // Fetch user data
            idSite: this.idSite, // Your site ID
            period: "range", // Use range period
            date: `${this.fromDate},${this.toDate}`, // Date range for the report
            format: "json", // Response format
            segment: segmentFilter, // Filter directly in API call
            token_auth: this.tokenAuth, // Authentication token
            random: Date.now() // Random parameter to avoid caching
          }
        });

        this.updateApiKeysData(response.data);
      } catch (error) {
        console.error("Error fetching data from Matomo:", error);
      }
    },

    async getConferenceInquiryStatistics() {
      const headers = getTokenHeader();
      const params = {
        principal: this.currentPrincipal,
        date: `${this.fromDate},${this.toDate}`
      };
      try {
        const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
        const { data } = await axios.get(
          `${env.poi_api_client_url}conferenceInquiry/statistics`,
          {
            params,
            headers
          }
        );
        return data;
      } catch (err) {
        await this.$store.dispatch("createError", err);
      }
    },

    updateTotalVisits(data) {
      this.totalVisits = data?.nb_actions || 0;
    },
    updateChartData(data) {
      // Check if data keys are single dates (daily) or date ranges (weekly)
      const isWeekly = Object.keys(data).some(date => date.includes(","));

      // Generate labels
      const labels = Object.keys(data).map(dateKey => {
        if (isWeekly) {
          // Weekly: Format as "DD.MM.YYYY - DD.MM.YYYY"
          const [startDate, endDate] = dateKey.split(",");
          return `${new Date(startDate).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })} - ${new Date(endDate).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          })}`;
        } else {
          // Daily: Format as "DD.MM.YYYY"
          return new Date(dateKey).toLocaleDateString("de-DE", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
          });
        }
      });

      const viewsData = labels.map((_, index) => {
        const dateKey = Object.keys(data)[index]; // Get the original date key
        const pageviewsData = data[dateKey];

        if (Array.isArray(pageviewsData) && pageviewsData.length > 0) {
          return pageviewsData[0]?.nb_hits || 0; // Use nb_hits if it's an array (adjust if needed)
        }

        if (typeof pageviewsData === "object" && pageviewsData !== null) {
          return pageviewsData?.nb_pageviews || 0; // Use nb_pageviews if it's a direct object
        }

        return 0; // Default case (empty array or undefined)
      });

      // Update the chart data object
      this.sumVisitsChartConfig.sumVisitsData = {
        labels: labels,
        datasets: [
          {
            label: "Seitenaufrufe",
            backgroundColor: "#00636C",
            borderColor: "#00636C",
            borderWidth: 2,
            data: viewsData,
            fill: false
          }
        ]
      };

      // If chart ref exists, re-render the chart
      if (this.$refs.sumVisitsChart) {
        this.$refs.sumVisitsChart.render();
      }
    },
    updateReferersData(data) {
      // Process the data to get the top 10 referers
      const referers = data
        .sort((a, b) => b.nb_actions - a.nb_actions) // Sort by nb_actions (descending)
        .slice(0, 10) // Limit to top 10
        .map(item => ({
          name: item.label, // Referer name
          visits: item.nb_actions // Number of actions (visits)
        }));

      // Update the referers table
      this.tableReferer = referers;
    },
    normalizeTitle(label) {
      if (!label) return "";
      // mehrfach-Whitespace zu einem, trimmen, lowercase
      const norm = String(label)
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
      return norm;
    },
    updatePageTitlesData(data) {
      const pageTitles = (Array.isArray(data) ? data : [])
        //.filter(item => !this.isUndefinedTitle(item?.label))
        .sort((a, b) => (b.nb_hits || 0) - (a.nb_hits || 0))
        .slice(0, 10)
        .map(item => ({
          name: item.label,
          visits: item.nb_hits || 0
        }));

      this.tableItems = pageTitles;

      if (this.isNews) {
        this.tableItems.forEach((item, i) => {
          this.getNewsLikesByTitle(item.name).then(likes => {
            this.$set(this.tableItems[i], "likes", likes);
          });
        });
      }
    },
    updateApiKeysData(data) {
      const pageApiKeys = data
        .sort((a, b) => b.nb_actions - a.nb_actions) // Sort by number of hits (descending)
        .slice(0, 100) // Limit to top 10 items
        .map(item => ({
          apikey: item.label,
          name: this.apiKeysMap[item.label], // Page title (label)
          visits: item.nb_actions // Number of hits (or nb_visits, depending on your needs)
        }));
      this.tableApiKeys = pageApiKeys;
    },
    async getNewsLikesByTitle(title) {
      const params = {
        query: title.trim(),
        principal_id: this.currentPrincipal,
        limit: 1
      };
      const headers = getTokenHeader();
      const response = await axios.get(env.news_api_client_url + "news", {
        headers,
        params
      });
      const news = response.data?.[0];
      if (!news?.likes) {
        return 0;
      }

      if (this.selectedApiKey) {
        if (news.likes[this.selectedApiKey] !== undefined) {
          return news.likes[this.selectedApiKey];
        }
        return 0;
      }
      return Object.values(news.likes).reduce((sum, count) => sum + count, 0);
    }
  },
  computed: {
    computedFromDate() {
      return this.fromDate ? moment(this.fromDate).format("DD.MM.YYYY") : "";
    },
    computedToDate() {
      return this.toDate ? moment(this.toDate).format("DD.MM.YYYY") : "";
    },
    apiKeys() {
      if (this.entityType === "news") {
        return this.$store.state.newsConfig?.apiKeys || [];
      } else if (this.entityType === "poi") {
        return this.$store.state.apiKeys || [];
      } else if (this.entityType === "event") {
        return this.$store.state.eventConfig?.apiKeys || [];
      }
      return [];
    },
    apiKeysArray() {
      return this.apiKeys.map(key => key.apiKey);
    },
    apiKeysMap() {
      return this.apiKeys.reduce((map, key) => {
        map[key.apiKey] = key.description;
        return map;
      }, {});
    },
    currentPrincipal() {
      return this.$store.state?.selectedPrincipal?.id;
    },
    categoryTypes() {
      return this.$store.state?.categoryTypes ?? [];
    },
    hasConferences() {
      if (this.entityType !== "poi") {
        return false;
      }
      return this.categoryTypes.some(
        type =>
          type._id === "68b6a81ce46e77e5da996de5" ||
          type.title.toLowerCase().includes("tagung")
      );
    },
    isNews() {
      return this.entityType === "news";
    }
  },
  watch: {
    fromDate() {
      this.fetchData();
    },
    toDate() {
      this.fetchData();
    },
    selectedResolution() {
      this.fetchData();
    },
    selectedNews() {
      this.fetchData();
    },
    selectedApiKey() {
      this.fetchData();
    },
    currentPrincipal() {
      this.fetchLatestNews();
      this.fetchData(); // Fetch initial data
      this.$forceUpdate();
    }
  },
  created() {
    this.fetchLatestNews();
    this.fetchData(); // Fetch initial data
  }
};
